import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import FlightsDatePicker from './FlightsDatePicker'
import FlightsVerticalDatePicker from './FlightsVerticalDatePicker'

interface Props {
  minDate: Date
  maxDate: Date
  id: string
  featuredRanges?: Array<{
    start: Date
    end: Date
  }>
}

function FlightsResultsDatePicker(props: Props) {
  const { minDate, maxDate, id, featuredRanges } = props

  return <>
    <CSSBreakpoint max="mobile" dynamic>
      <FlightsVerticalDatePicker
        minDate={minDate}
        maxDate={maxDate}
        id={id}
        required
        featuredRanges={featuredRanges}
        mobileResultsRedesign
        hideDayLabels
        distinguishActiveLeg
      />
    </CSSBreakpoint>
    <CSSBreakpoint min="tablet" dynamic>
      <FlightsDatePicker
        minDate={minDate}
        maxDate={maxDate}
        type="dual"
        id={id}
        required
        featuredRanges={featuredRanges}
        hideDayLabels
        resultsCalendar
        keepOpenOnSelect
        distinguishActiveLeg
      />
    </CSSBreakpoint>
  </>
}

export default FlightsResultsDatePicker
